import React from 'react';
import Layout from '../Layout';

const ProductListView = (props) => (
  <Layout {...props} type="ProductListView"/>
)
export default ProductListView;



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Content/ProductListView.js